<template>
  <b-container>
    <b-row
      ><b-col md="12"><h2 class="text-left">Állandó szolgáltatások</h2></b-col></b-row
    >
    <b-row
      ><b-col md="12 mb-4"
        ><button type="button" name="button" class="btn btn-primary mb-1 float-left" @click="createClicked()">
          Új szolgáltatás hozzáadása
        </button></b-col
      ></b-row
    >
    <b-row>
      <b-col md="4" v-for="(service, index) in services" v-bind:key="service._id" class="mb-1 mb-0 mr-0">
        <p>{{ service.order }}.</p>
        <b-col>
          <div class="constant-services-holder-box">{{ service.name }}</div>
        </b-col>
        <b-row class="mt-2">
          <b-col class="mb-0 mr-0"
            ><button
              v-if="index !== 0"
              type="button"
              name="button"
              class="btn btn-secondary add-button"
              @click="leftClicked(index)"
            >
              {{ left }}
            </button>
          </b-col>
          <b-col md="6 mr-0 ml-0"
            ><button
              v-if="index !== services.length - 1"
              type="button"
              name="button"
              class="btn btn-secondary add-button"
              @click="rightClicked(index)"
            >
              {{ right }}
            </button>
          </b-col>
        </b-row>
        <b-row
          ><b-col md="12"
            ><button
              type="button"
              name="button"
              class="btn btn-primary add-button mt-3"
              @click="editClicked(service._id)"
            >
              Szerkesztés
            </button></b-col
          ></b-row
        ><b-row
          ><b-col md="12"
            ><button
              type="button"
              name="button"
              class="btn btn-secondary add-button mt-3 mb-3"
              @click="deleteClicked(service._id)"
            >
              Törlés
            </button></b-col
          ></b-row
        ></b-col
      >
    </b-row>
  </b-container>
</template>
<script>
import { deleteService, listServices, reorderService } from '../../api/service'
export default {
  name: 'Service',
  data: function() {
    return {
      loading: true,
      services: [],
      left: '<--',
      right: '-->'
    }
  },
  methods: {
    createClicked: function() {
      this.$router.push('/contents/services/create')
    },
    editClicked: function(id) {
      this.$router.push({ path: '/contents/services/edit', query: { id } })
    },
    deleteClicked: async function(id) {
      await deleteService(id)
      await this.fetchServices()
    },
    fetchServices: async function() {
      const services = await listServices()
      this.services = services
    },
    leftClicked: async function(index) {
      let updatedServices = [...this.services.map(service => ({ id: service._id, order: service.order }))]
      const currentService = updatedServices[index]
      const beforeService = updatedServices[index - 1]
      updatedServices[index] = { id: beforeService.id, order: beforeService.order + 1 }
      updatedServices[index - 1] = { id: currentService.id, order: currentService.order - 1 }
      await reorderService(updatedServices)
      await this.fetchServices()
    },
    rightClicked: async function(index) {
      let updatedServices = [...this.services.map(service => ({ id: service._id, order: service.order }))]
      updatedServices[index] = { id: updatedServices[index].id, order: updatedServices[index].order + 1 }
      updatedServices[index + 1] = { id: updatedServices[index + 1].id, order: updatedServices[index + 1].order - 1 }
      await reorderService(updatedServices)
      await this.fetchServices()
    }
  },
  created: async function() {
    await this.fetchServices()
  }
}
</script>
<style scoped>
.service-container {
  margin-left: 25px;
  margin-right: 25px;
}

.add-button {
  width: inherit;
}

p {
  text-align: left;
  margin-bottom: 3px;
}
.constant-services-holder-box {
  padding: 25px;
  border-top-right-radius: 0px;
  color: var(--color-green);
  position: relative;
  padding-left: 75px;
  font-size: 22px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  box-shadow: 0px 0px 8px rgba(45, 52, 54, 0.05);
  border-radius: 16px 0px 16px 16px;
}

.constant-services-holder-box:before {
  content: ' ';
  display: block;
  position: absolute;
  right: 0;
  top: 25%;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.7;
  background-image: url('../../assets/img/logo/vekonyvali_hollow.svg');
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 50px;
}
</style>
